




















import Vue from 'vue';
import Fetch from '@/lib/fetch.ts';
import router from '@/router';
import { Route } from 'vue-router';

export default Vue.extend({
    data() {
        return {
            registration: false,
            displayName: '',
            username: '',
            password: '',
        };
    },
    async beforeRouteEnter(to: Route, from: Route, next: any) {
        next(async (vm: any) => {
            const canRegister: number = await Fetch.get('/api/regstatus');
            if (to.path === '/register' && canRegister === 0) {
                next('/login');
            } else if (to.path === '/register' && canRegister === 1) {
                vm.registration = true;
            }
        });
    },
    methods: {
        async login() {
            const resp = await Fetch.post('/api/login',
                {
                    Name: this.username.trim(),
                    Password: this.password.trim(),
                });
            if (resp !== null) {
                Vue.$cookies.set('token', resp.token);
                Vue.$cookies.set('user', resp.user.ID);
                Vue.$cookies.set('authenticated', true);
                await router.push('/management');
            }
        },
        async register() {
            const registration = await Fetch.post('/api/register',
                {
                    displayName: this.displayName,
                    name: this.username.trim(),
                    password: this.password.trim(),
                });
            if (registration) {
                await this.$router.push('/login');
            }
        },
    },
    computed: {
        authMode() {
            const self: any = this;
            return self.registration ? self.register : self.login;
        },
    },
});
